import { canOpenTierView, TIER_VIEW_TABS, tierViewPath } from '@/config/membershipTierView'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'

const tierIdOf = audience => audience?.relationships?.membership_tier?.data?.id

// Same shape as buildFeatureGuard: the router hands it the logged-in user getter.
export const buildTierListGuard = getUser => async to => {
  if (!canOpenTierView(getUser())) return true
  let audience = mapRelationship({ type: 'audience', id: to.params.id })
  if (!audience) {
    try {
      const response = await api.call('GET', `audiences/${to.params.id}?included=none`)
      audience = response.data.data
    } catch {
      return true
    }
  }
  const tierId = tierIdOf(audience)
  if (!tierId) return true
  return tierViewPath(tierId, TIER_VIEW_TABS.includes(to.params.tab) ? to.params.tab : undefined)
}
